export const constellationBlueprint = {
  id: "celestial-constellation-id",
  name: "Galvionic Planar Constellation",
  quadrants: [
    // Source Plane
    {
      id: "sahs",
      displayName: "Sahs",
      backgroundColor: "#FFFFFF",
      children: ["eith", "kat", "oka", "far", "ven", "kro", "val", "quin"],
      top: "50%",
      left: "50%",
      disabled: true,
      inUse: false,
    },
    // Sin Planes
    {
      id: "eith",
      displayName: "Eith",
      backgroundColor: "#FFFFFF",
      children: ["sahs", "quin", "rey", "kor", "gai", "kat"],
      top: "35%",
      left: "50%",
      disabled: true,
      inUse: false,
    },
    {
      id: "kat",
      displayName: "Kat",
      backgroundColor: "#00FFFF",
      children: ["sahs", "eith", "oka", "gai"],
      top: "40%",
      left: "60%",
      disabled: true,
      inUse: false,
    },
    {
      id: "oka",
      displayName: "Oka",
      backgroundColor: "#FF0000",
      children: ["sahs", "kat", "gai", "shen", "ron", "far"],
      top: "50%",
      left: "65%",
      disabled: true,
      inUse: false,
    },
    {
      id: "far",
      displayName: "Far",
      backgroundColor: "#A52A2A",
      children: ["sahs", "oka", "ron", "ven"],
      top: "60%",
      left: "60%",
      disabled: true,
      inUse: false,
    },
    {
      id: "ven",
      displayName: "Ven",
      backgroundColor: "#FDD907",
      children: ["sahs", "far", "ron", "hel", "ork", "kro"],
      top: "65%",
      left: "50%",
      disabled: true,
      inUse: false,
    },
    {
      id: "kro",
      displayName: "Kro",
      backgroundColor: "#EAADEA",
      children: ["sahs", "ven", "ork", "val"],
      top: "60%",
      left: "40%",
      disabled: true,
      inUse: false,
    },
    {
      id: "val",
      displayName: "Val",
      backgroundColor: "#808080",
      children: ["sahs", "kro", "fintra", "quin"],
      top: "50%",
      left: "35%",
      disabled: true,
      inUse: false,
    },
    {
      id: "quin",
      displayName: "Quin",
      backgroundColor: "#00FF00",
      children: ["sahs", "val", "rey", "eith"],
      top: "40%",
      left: "40%",
      disabled: true,
      inUse: false,
    },
    // Foundational Planes
    {
      id: "kor",
      displayName: "Kor",
      backgroundColor: "#FFFF00",
      children: ["rey", "eith", "gai"],
      top: "20%",
      left: "50%",
      disabled: true,
      inUse: false,
    },
    {
      id: "gai",
      displayName: "Gai",
      backgroundColor: "#90EE90",
      children: ["kor", "eith", "kat", "oka", "lo", "ilthe", "on", "shen"],
      top: "30%",
      left: "70%",
      disabled: true,
      inUse: false,
    },
    {
      id: "shen",
      displayName: "Shen",
      backgroundColor: "#FFA500",
      children: ["gai", "oka", "ron", "purgis", "troy"],
      top: "50%",
      left: "80%",
      disabled: true,
      inUse: false,
    },
    {
      id: "ron",
      displayName: "Ron",
      backgroundColor: "#4169e1",
      children: ["far", "oka", "shen", "gran", "vox", "vo", "hel", "ven"],
      top: "70%",
      left: "70%",
      disabled: true,
      inUse: false,
    },
    {
      id: "hel",
      displayName: "Hel",
      backgroundColor: "#FF00FF",
      children: ["ork", "ven", "ron"],
      top: "80%",
      left: "50%",
      disabled: true,
      inUse: false,
    },
    {
      id: "ork",
      displayName: "Ork",
      backgroundColor: "#e75480",
      children: ["zul", "gor", "jir", "fintra", "ven", "hel", "kro"],
      top: "70%",
      left: "30%",
      disabled: true,
      inUse: false,
    },
    {
      id: "fintra",
      displayName: "Fintra",
      backgroundColor: "#F8F8F8",
      children: ["thal", "tor", "rey", "val", "ork"],
      top: "50%",
      left: "20%",
      disabled: true,
      inUse: false,
    },
    {
      id: "rey",
      displayName: "Rey",
      backgroundColor: "#5B2D82",
      children: ["fintra", "it", "gal", "gru", "kor", "eith", "quin"],
      top: "30%",
      left: "30%",
      disabled: true,
      inUse: false,
    },
    // Creation Emergent Planes
    {
      id: "lo",
      displayName: "Lo",
      backgroundColor: "#7BB661",
      children: ["ilthe", "gai"],
      top: "10%",
      left: "70%",
      disabled: true,
      inUse: false,
    },
    {
      id: "ilthe",
      displayName: "Ilthe",
      backgroundColor: "#4B9B4B",
      children: ["lo", "on", "gai"],
      top: "20%",
      left: "80%",
      disabled: true,
      inUse: false,
    },
    {
      id: "on",
      displayName: "On",
      backgroundColor: "#66BB66",
      children: ["gai", "purgis", "ilthe"],
      top: "30%",
      left: "90%",
      disabled: true,
      inUse: false,
    },
    // Life Emergent Planes
    {
      id: "purgis",
      displayName: "Purgis",
      backgroundColor: "#FFDAB9",
      children: ["on", "shen", "troy"],
      top: "42.5%",
      left: "90%",
      disabled: true,
      inUse: false,
    },
    {
      id: "troy",
      displayName: "Troy",
      backgroundColor: "#FFFACD",
      children: ["shen", "gran", "purgis"],
      top: "57.5%",
      left: "90%",
      disabled: true,
      inUse: false,
    },
    // Improvement Emergent Planes
    {
      id: "gran",
      displayName: "Gran",
      backgroundColor: "#ADD8E6",
      children: ["ron", "troy", "vox"],
      top: "70%",
      left: "90%",
      disabled: true,
      inUse: false,
    },
    {
      id: "vox",
      displayName: "Vox",
      backgroundColor: "#B0E0E6",
      children: ["gran", "vo", "ron"],
      top: "80%",
      left: "80%",
      disabled: true,
      inUse: false,
    },
    {
      id: "vo",
      displayName: "Vo",
      backgroundColor: "#87CEFA",
      children: ["vox", "ron"],
      top: "90%",
      left: "70%",
      disabled: true,
      inUse: false,
    },
    // Lies Emergent Planes
    {
      id: "jir",
      displayName: "Jir",
      backgroundColor: "#CDA4A3",
      children: ["gor", "ork"],
      top: "90%",
      left: "30%",
      disabled: true,
      inUse: false,
    },
    {
      id: "gor",
      displayName: "Gor",
      backgroundColor: "#DB7093",
      children: ["zul", "jir", "ork"],
      top: "80%",
      left: "20%",
      disabled: true,
      inUse: false,
    },
    {
      id: "zul",
      displayName: "Zul",
      backgroundColor: "#F4A8C4",
      children: ["thal", "ork", "gor"],
      top: "70%",
      left: "10%",
      disabled: true,
      inUse: false,
    },
    // Death Emergent Planes
    {
      id: "thal",
      displayName: "Thal",
      backgroundColor: "#FFFFFF",
      children: ["tor", "fintra", "zul"],
      top: "57.5%",
      left: "10%",
      disabled: true,
      inUse: false,
    },
    {
      id: "tor",
      displayName: "Tor",
      backgroundColor: "#FFFFFF",
      children: ["fintra", "it", "thal"],
      top: "42.5%",
      left: "10%",
      disabled: true,
      inUse: false,
    },
    // Change Emergent Planes
    {
      id: "gru",
      displayName: "Gru",
      backgroundColor: "#CAB3E6",
      children: ["gal", "rey"],
      top: "10%",
      left: "30%",
      disabled: true,
      inUse: false,
    },
    {
      id: "gal",
      displayName: "Gal",
      backgroundColor: "#9E86C6",
      children: ["gru", "rey", "it"],
      top: "20%",
      left: "20%",
      disabled: true,
      inUse: false,
    },
    {
      id: "it",
      displayName: "It",
      backgroundColor: "#CBC3E3",
      children: ["gal", "tor", "rey"],
      top: "30%",
      left: "10%",
      disabled: true,
      inUse: false,
    },
  ],
};
